import { Option } from '@vendasta/forms';

export const CONTRACT_DURATION_FORM_NAME = 'contractDuration';
export const CONTRACT_DURATION_FORM_PERIOD = 'contractDurationPeriod';
export const CONTRACT_DURATION_FORM_VALUE = 'contractDurationValue';

export interface PartnerMarketConfig {
  partnerId: string;
  marketId: string;
  bypassQuantityLimit: boolean;
  currency: string;
}

export interface TagOption extends Option {
  value: string;
}

export type CreateSourceLocation = 'pipeline' | 'company-profile';

export interface CreateOpportunityPageData {
  sourceLocation?: CreateSourceLocation;
  navigateOnSuccess?: boolean;
}
